import { createAsyncThunk } from '@reduxjs/toolkit';

import type { ChargePurchasesRequestType } from 'redux-store/slices/purchases/types';

import doFetch from 'utils/doFetch';

import type { AppGetState } from '../../index';

const chargePurchaseThunk = createAsyncThunk(
  'purchases/chargePurchase',
  async (
    params: ChargePurchasesRequestType & {
      extra?: { interval: string; discount?: number; price: string | number };
    },
    { getState },
  ) => {
    const { extra, ...rest } = params;
    const apiPointName = 'chargePurchase';
    const store = (getState as AppGetState)();
    const token = store.jwt.token;
    let headers = {};

    if (token) {
      headers = {
        ...headers,
        Authorization: `Bearer ${token}`,
      };
    }

    const result = await doFetch<typeof apiPointName>({
      apiPointName,
      body: rest,
      headers,
    });

    return { ...extra, ...result, params };
  },
);

export default chargePurchaseThunk;
